import React, { Component } from 'react'
import { connect } from 'react-redux'
import './photo.scss'

import { FILE_STORAGE } from '../../../../constants'

import { deleteDeviationFileFromOrder, uploadMultipleFiles, createFileContainer, UpdateOrderFileSelection } from '../../../../actions/orders'

import { translation } from '../../../../utils/helpers'

import Dropzone from '../../Dropzone'
import Gallery from '../../Gallery'
import Portal from '../../Portal'
import Confirm from '../../Confirm'

// Modals
import PhotoMarkModal from '../../../modals/PhotoMarkModal'

// Elements
import PanelHeader from '../../../elements/panelHeader'
import Check from '../../../elements/check'
// import Grid from '../../../elements/grid'
import RemoveButton from '../../../elements/removeButton'

class Photo extends Component {
  constructor (props) {
    super(props)
    this.state = {
      price: this.props.orderPrice !== undefined ? this.props.orderPrice : null,
      order: this.props.order !== undefined ? this.props.order : null,
      confirmImage: false,
      upload: {
        errors: []
      },
      addedImages: [],
      selectedImages: {}
    }
    this.isCheckCalling = false

    this.ensureFileContainer = this.ensureFileContainer.bind(this)
    this.onDropAccepted = this.onDropAccepted.bind(this)
    this.checkboxChange = this.checkboxChange.bind(this)
    this.markExisting = this.markExisting.bind(this)
    this.doUpload = this.doUpload.bind(this)
  }

  componentDidMount () {
    this.componentWillReceiveProps(this.props)
  }

  componentWillReceiveProps (next) {
    if (typeof next.orderPrice !== 'object' || typeof next.order !== 'object') return

    // Prevent removing added images when old order data is received in props.
    if ((this.state.order !== undefined && this.state.order !== null && this.state.order.OrderFiles !== null) && (next.order.OrderFiles === null || next.order.OrderFiles.length !== this.state.order.OrderFiles.length)) return

    let order = this.state.order
    let price = this.state.price
    if (typeof next.orderPrice === 'object') {
      price = next.orderPrice
    }

    if (order !== null && order.OrderFiles !== null && price !== null && price.Files !== null) {
      this.markExisting(order.OrderFiles, price.Files)
    }

    this.setState({
      order: order,
      price: price
    })
  }

  markExisting (markIn, lookIn) {
    let fromOrder = markIn
    let fromPrice = lookIn

    if (fromOrder !== null && fromOrder.length > 0 && fromPrice !== null && fromPrice.length > 0) {
      for (let o = 0; o < fromOrder.length; o++) {
        if (fromPrice.findIndex(file => file.OrderFileID === fromOrder[o].OrderFileID) !== -1) {
          fromOrder[o].newFile = true
        }
      }
    }
  }

  checkboxChange (e) {
    // in some cases this triggers multiple times at the same time. Only allow one call to enter at a time,
    if (this.isCheckCalling) return
    this.isCheckCalling = true

    let input = e.target
    if (e.target.tagName === 'DIV') {
      // if div click
      input = e.target.children[0]
      input.checked = !input.checked
    } else if (e.target.tagName === 'B') {
      // if b click
      input = e.target.parentElement.children[0]
      input.checked = !input.checked
    }

    this.setState({
      selectedImages: { ...this.state.selectedImages, [e.target.id]: e.target.checked }
    }, () => {
      // console.log('selectedImages', this.state.selectedImages)
    })

    let selected = []
    let inp = document.getElementsByTagName('input')
    for (let i = 0; i < inp.length; i++) {
      if (inp[i].name === 'checkbox_image' && inp[i].checked === true) {
        selected.push({
          OrderFileID: inp[i].id
        })
      }
    }
    let { price } = this.state
    price.SelectedOldFiles = selected

    let type = 5
    if (price.IsEvaluation) type = 6
    if (price.IsInternalDeviation) type = 2
    if (price.IsExternalDeviation) type = 3
    if (price.IsAfterEvaluation) type = 4

    let typeId = price.OrderPriceId
    if (type === 2 || type === 3) {
      typeId = price.Deviations[0].DeviationId
    }

    let fileIds = selected.map(s => s.OrderFileID)

    this.props.UpdateOrderFileSelection({
      OrderFileIds: fileIds,
      Type: type,
      TypeId: typeId
    })

    this.isCheckCalling = false
  }

  renderImages () {
    if (!this.state.order) return null

    const renderImage = (image, index) => {
      if (!image.IsImage) return null
      const deleteFile = () => {
        this.setState({
          confirmImage: image
        })
      }

      let isOlFile = false // = this.state.price.Deviations[0] && this.state.price.Deviations[0].DeviationFiles.filter(x => x.OrderFile.OrderFileID === image.OrderFileID).length === 1
      if (image.newFile === true || isOlFile) {
        return (
          <div key={index}>
            <div className='divImg'>
              <span className='delete'><RemoveButton size='s' onClick={deleteFile} /></span>
              <a href={image.FileURL} data-lightbox='gallery_2'>
                <img className='testImg' id={image.OrderFileID} name='oldImages' src={image.ThumbURL} />
              </a>
            </div>
            <div className='divCheckbox'>
              <Check spacing={0} labelText={translation('1218')} id={image.OrderFileID} name='checkbox_image' checked readOnly />
            </div>
          </div>
        )
      } else {
        return (
          <div key={index}>
            <div className='divImg'>
              <a href={image.FileURL} data-lightbox='gallery_2'>
                <img className={'testImg' + (!this.state.price.SelectedOldFiles || this.state.price.SelectedOldFiles.indexOf(x => x.OrderFileID === image.OrderFileID) === -1 ? ' faded' : '')} id={image.OrderFileID} name='oldImages' src={image.ThumbURL} />
              </a>
            </div>
            <div className='divCheckbox' onClick={this.checkboxChange} >
              <Check spacing={0} labelText={translation('1218')} id={image.OrderFileID} name='checkbox_image' onChange={this.checkboxChange} checked={this.state.selectedImages[image.OrderFileID] === true} />
            </div>
          </div>
        )
      }
    }

    // Return
    return (
      <Gallery files={this.state.order.OrderFiles} renderImage={renderImage} />
    )
  }

  closePhotoMarkModal (update) {
    this.props.triggerPopup(false)
    this.setState({
      photomark: {
        ...this.state.photomark,
        open: false
      }
    }, () => {
      if (update) {
        if (this.props.deviation === false) {
          this.props.getOrder(this.props.order.Id) // get workcard again to display added markings.
        }
        this.setState({
          imageKey: Math.random()
        })
      }
    })
  }

  ensureFileContainer (orderPriceId = null, deviationId = null) {
    if (this.state.fileContainerId === undefined || this.state.fileContainerId === null) {
      return this.props.createFileContainer(orderPriceId, deviationId).then((res) => {
        this.setState({
          fileContainerId: res.data.FileContainerId
        })
      })
    } else {
      return Promise.resolve()
    }
  }

  getType () {
    let type = 11
    if (this.state.price.IsAfterEvaluation) type = 2
    if (this.state.price.IsEvaluation) type = 3
    if (this.state.price.IsInternalDeviation) type = 7
    if (this.state.price.IsExternalDeviation) type = 8
    if (this.state.price.IsOtherDamage) type = 16

    return type
  }

  doUpload (files) {
    let priceObj = { ...this.state.price }
    let type = this.getType()
    const isDeviation = [7, 8].includes(type)

    let orderPriceId = priceObj.OrderPriceId
    let deviationId = null
    if (isDeviation) {
      orderPriceId = null
      deviationId = priceObj.Deviations[0].DeviationId
    }

    return new Promise((resolve, reject) => {
      this.ensureFileContainer(orderPriceId, deviationId).then(() => {
        let fileContainerId = this.state.fileContainerId
        this.props.uploadMultipleFiles(files, this.state.order.Id, type, priceObj.OrderPriceId, fileContainerId).then((res) => {
          if (isDeviation) {
            // Save file to deviations
            res.data.map((uplVal) => {
              priceObj.Deviations[0].DeviationFiles.push({
                FileName: uplVal.ActualFileName,
                DeviationId: priceObj.Deviations[0].DeviationId,
                OrderFile: uplVal
              })
            })
            this.setState({
              price: priceObj
            }, () => {
              this.props.saveOrderPrice(this.state.price).then(() => {
                // this.props.loadOrder(true)
                resolve(res)
              })
            })
            return
          } else {
            // Not deviation
            resolve(res)
          }
        }, (err) => {
          reject(err)
        })
      })
    })
  }

  onDropAccepted (files) {
    this.doUpload(files).then(res => {
      let images = [...this.state.order.OrderFiles]
      res.data.forEach((orderFile) => {
        images.push({
          FileURL: FILE_STORAGE + orderFile.RealFileURL,
          ThumbURL: FILE_STORAGE + orderFile.RealThumbURL,
          OrderFileID: orderFile.OrderFileID,
          IsImage: true,
          newFile: true
        })
      }, this)

      this.setState({
        order: {
          ...this.state.order,
          OrderFiles: images
        }
      })
    }, (err) => {
      // Upload failed error
      console.log('upload err', err)
      window.toastr.error(translation('960'), translation('216'))
    })
  }

  onDropRejected (files) {
    let newErrors = []
    files.map((val, index) => {
      newErrors.push(translation('1207') + ': ' + val.name + ' ' + translation('13405') + '.')
    })
    this.setState({ upload: { errors: newErrors } })
  }

  render () {
    let isMultipleUpload = true

    // Confirm
    const onPortalClose = () => {
      this.setState({
        confirmImage: false
      })
    }
    const onConfirm = () => {
      this.props.deleteDeviationFileFromOrder(this.state.confirmImage).then((res) => {
        for (var i = 0; i < this.state.order.OrderFiles.length; i++) {
          if (this.state.order.OrderFiles[i].OrderFileID === this.state.confirmImage.OrderFileID) {
            this.state.order.OrderFiles.splice(i, 1)
            i--
          }
        }
        onPortalClose()
      }, () => {
        onPortalClose()
        // Toastr
        window.toastr.error(translation('1918'), translation('216'))
      })
    }

    const renderError = (error, index) => {
      return <p key={index}>{error}</p>
    }

    return (
      <div className='price_photo'>
        <PanelHeader text={translation('1011')} />
        {this.state.upload.errors.length !== 0 && <div className='alert alert-danger'>{this.state.upload.errors.map(renderError)}</div>}
        <Dropzone
          onDrop={() => { this.setState({ upload: { errors: [] } }) }}
          onDropAccepted={this.onDropAccepted}
          onDropRejected={this.onDropRejected.bind(this)}
          multiple={isMultipleUpload}
          includeCircles={false}>
          <p>{translation('13397')}</p>
        </Dropzone>
        {this.renderImages()}
        {this.state.confirmImage !== false && (
          <Portal className='deleteModal' onPortalClose={onPortalClose}>
            <Confirm confirm={onConfirm} notConfirm={onPortalClose} />
          </Portal>
        )}
        {false && this.state.photomark.open && (
          <PhotoMarkModal
            show={this.state.photomark.open}
            image={this.state.photomark.image}
            onClose={this.closePhotoMarkModal.bind(this)} />
        )}
      </div>
    )
  }
}

export default connect(null, {
  deleteDeviationFileFromOrder,
  createFileContainer,
  uploadMultipleFiles,
  UpdateOrderFileSelection
})(Photo)



// WEBPACK FOOTER //
// ./src/app/shared/components/Extent/Photo/index.js